import { z } from "zod";
import { npdInitialGuessesHintDtoSchema } from "../npd-initial-guesses-hint";
import { npdFormulationDtoSchema } from "./npd-formulation.schema";
export const npdFormulationRequestDtoSchema = z.object({
    formulation: npdFormulationDtoSchema,
    initialGuessesHint: z.optional(npdInitialGuessesHintDtoSchema),
});
